import React from 'react'
import type { ContextUploadFileItem } from './message'
import { MessageUploadCard } from './MessageUploadCard'

export interface MessageUploadCardsContainerProps {
  uploads: ContextUploadFileItem[]
}

/**
 * Container for displaying upload cards above user messages.
 * Figma specs: Right-aligned, 3 cards per row max, 8px gap, flex-wrap.
 */
export const MessageUploadCardsContainer: React.FC<MessageUploadCardsContainerProps> = ({
  uploads
}) => {
  if (!uploads || uploads.length === 0) {
    return null
  }

  return (
    <div
      className='flex flex-wrap justify-end'
      style={{
        gap: '8px',
        maxWidth: '720px',
        marginLeft: 'auto' // Right-align the container
      }}
    >
      {uploads.map((upload, index) => (
        <MessageUploadCard key={index} upload={upload} />
      ))}
    </div>
  )
}

export default MessageUploadCardsContainer
